import { render } from "./notFound.vue?vue&type=template&id=1f91dad5"
const script = {}

import exportComponent from "C:\\Server\\Document\\live-class-front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__